import { generateRawAesKey } from './aes-gcm'

const KEY_PREFIX = 'ek_' as const

export const generateEncryptionKey = async (): Promise<string> => {
  const rawBase64 = await generateRawAesKey()
  return `${KEY_PREFIX}${rawBase64}`
}

export const stripKeyPrefix = (formattedKey: string): string => {
  if (!formattedKey.startsWith(KEY_PREFIX)) {
    throw new Error(`Invalid key format: expected "${KEY_PREFIX}" prefix`)
  }
  return formattedKey.slice(KEY_PREFIX.length)
}

export const hasKeyPrefix = (value: string): boolean => {
  return value.startsWith(KEY_PREFIX)
}
